// extracted by mini-css-extract-plugin
export default {"layoutContent":"layoutContent_layoutContent__4DHCY"};